import {
  SET_RETURNS,
  SET_LOADING_RETURN_ID,
  SELECT_RETURN,
  SET_SEARCH_RETURNS_ACTION,
  SET_SEARCH_RETURNS_QUERY,
  CLEAR_RETURNS,
  CLEAR_RETURNS_SEARCH_STATE,
} from '../../../../constants/returnsSearchActionTypes';

export const setSearchReturnsQuery = (query) => ({
  type: SET_SEARCH_RETURNS_QUERY,
  query,
});

export const setSearchReturnsAction = (action) => {
  return {
    type: SET_SEARCH_RETURNS_ACTION,
    action: action,
  };
};

export const selectReturn = (orderReturn) => ({
  type: SELECT_RETURN,
  return: orderReturn,
});

export const setLoadingReturnId = (return_id) => ({
  type: SET_LOADING_RETURN_ID,
  return_id,
});

export const setReturns = (returns) => ({
  type: SET_RETURNS,
  returns,
});

export const clearReturns = () => ({
  type: CLEAR_RETURNS,
});

export const clearReturnSearchState = () => ({
  type: CLEAR_RETURNS_SEARCH_STATE,
});
